export default defineNuxtPlugin(() => {
  // Skip widget in development or demo mode
  if (import.meta.dev) return

  const isDemoActive = sessionStorage.getItem('demo-mode') === 'true'
  if (isDemoActive) return

  const { user } = useAuth()

  // Load Zendesk Web Widget script
  useHead({
    script: [
      {
        id: 'ze-snippet',
        src: 'https://static.zdassets.com/ekr/snippet.js?key=1a18e9c5-c276-4693-aef7-a083d70700b7',
        defer: true
      }
    ]
  })

  // Identify user once widget loads
  const unwatch = watch(
    () => window.zE,
    (zE) => {
      if (zE && user.value) {
        zE('webWidget', 'identify', {
          name: user.value.name || `${user.value.givenName || ''} ${user.value.familyName || ''}`.trim() || user.value.username,
          email: user.value.email
        })
        unwatch()
      }
    },
    { immediate: true }
  )

  // Cleanup watcher when scope is disposed to prevent memory leaks
  onScopeDispose(() => {
    unwatch()
  })
})
